export const CommonQueryKeys = {
  startCallingModal: ["query_key_start_calling_modal"],
  campaign: (campaignId: string | undefined) => ["campaign", campaignId],
};
